"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificateFields = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_panel_1 = require("../../composite/form/fields/form-panel");
const form_file_field_1 = require("../../composite/form/fields/form-file-field");
const form_text_field_1 = require("../../composite/form/fields/form-text-field");
function CertificateFields() {
    const intl = react_intl_1.useIntl();
    return (react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_CERTIFICATES_PANEL_TITLE", defaultMessage: "Certifik\u00E1t" }) },
        react_1.default.createElement(form_file_field_1.FormFileField, { name: "content", required: true, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_CERTIFICATES_FIELD_LABEL_CONTENT", defaultMessage: "Obsah" }), helpLabel: intl.formatMessage({
                id: 'EAS_CERTIFICATES_FIELD_HELP_CONTENT',
                defaultMessage: 'PFX, P12 nebo JKS soubor',
            }) }),
        react_1.default.createElement(form_text_field_1.FormTextField, { name: "password", required: true, type: "password", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_CERTIFICATES_FIELD_LABEL_PASSWORD", defaultMessage: "Heslo" }), helpLabel: intl.formatMessage({
                id: 'EAS_CERTIFICATES_FIELD_HELP_PASSWORD',
                defaultMessage: ' ',
            }) })));
}
exports.CertificateFields = CertificateFields;
//# sourceMappingURL=certificates-fields.js.map